var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlides(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7225_3431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 16,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1H5.5C4.675 1 4 1.675 4 2.5V21.5C4 22.325 4.675 23 5.5 23H18.5C19.325 23 20 22.325 20 21.5V6.99999L14 1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7225_3431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1H5.5C4.675 1 4 1.675 4 2.5V21.5C4 22.325 4.675 23 5.5 23H18.5C19.325 23 20 22.325 20 21.5V6.99999L16.5 4.49999L14 1Z",
    fill: "#F4B400"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7225_3431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 16,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1H5.5C4.675 1 4 1.675 4 2.5V21.5C4 22.325 4.675 23 5.5 23H18.5C19.325 23 20 22.325 20 21.5V6.99999L14 1Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7225_3431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.25 11H8.74999C8.3375 11 8 11.3375 8 11.75V18.25C8 18.6625 8.3375 19 8.74999 19H15.25C15.6625 19 16 18.6625 16 18.25V11.75C16 11.3375 15.6625 11 15.25 11ZM15 16.75H8.99999V13.25H15V16.75Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7225_3431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 16,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1H5.5C4.675 1 4 1.675 4 2.5V21.5C4 22.325 4.675 23 5.5 23H18.5C19.325 23 20 22.325 20 21.5V6.99999L14 1Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7225_3431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4388 6.56125L20 12.1212V6.99999L14.4388 6.56125Z",
    fill: "url(#paint0_linear_7225_3431)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7225_3431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 16,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1H5.5C4.675 1 4 1.675 4 2.5V21.5C4 22.325 4.675 23 5.5 23H18.5C19.325 23 20 22.325 20 21.5V6.99999L14 1Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7225_3431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1V5.50001C14 6.32876 14.6713 6.99999 15.5 6.99999H20L14 1Z",
    fill: "#FADA80"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7225_3431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 16,
    height: 22
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1H5.5C4.675 1 4 1.675 4 2.5V21.5C4 22.325 4.675 23 5.5 23H18.5C19.325 23 20 22.325 20 21.5V6.99999L14 1Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7225_3431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1V1.125L19.875 6.99999H20L14 1Z",
    fill: "white",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_7225_3431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 16,
    height: 22
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1H5.5C4.675 1 4 1.675 4 2.5V21.5C4 22.325 4.675 23 5.5 23H18.5C19.325 23 20 22.325 20 21.5V6.99999L14 1Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_7225_3431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1C4.675 1 4 1.675 4 2.5V2.625C4 1.8 4.675 1.125 5.5 1.125H14V1H5.5Z",
    fill: "white",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_7225_3431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 16,
    height: 22
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1H5.5C4.675 1 4 1.675 4 2.5V21.5C4 22.325 4.675 23 5.5 23H18.5C19.325 23 20 22.325 20 21.5V6.99999L14 1Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_7225_3431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22.875H5.5C4.675 22.875 4 22.2 4 21.375V21.5C4 22.325 4.675 23 5.5 23H18.5C19.325 23 20 22.325 20 21.5V21.375C20 22.2 19.325 22.875 18.5 22.875Z",
    fill: "#BF360C",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_7225_3431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 16,
    height: 22
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1H5.5C4.675 1 4 1.675 4 2.5V21.5C4 22.325 4.675 23 5.5 23H18.5C19.325 23 20 22.325 20 21.5V6.99999L14 1Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_7225_3431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7C14.6713 7 14 6.32876 14 5.50002V5.625C14 6.45376 14.6713 7.125 15.5 7.125H20V7H15.5Z",
    fill: "#BF360C",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7225_3431",
    x1: 17.2197,
    y1: 7.03864,
    x2: 17.2197,
    y2: 12.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF360C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF360C",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlides);
export default __webpack_public_path__ + "static/media/slides.40f013d295ca36888107547ff01626ea.svg";
export { ForwardRef as ReactComponent };